
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"13","viewBox":"0 0 19 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.262 2.242c.066.266.122.598.166.996.066.399.11.797.133 1.196.022.376.033.73.033 1.062.022.332.033.609.033.83v.299c0 1.992-.122 3.464-.365 4.416-.111.376-.31.708-.598.996-.288.288-.63.487-1.03.598-.42.11-1.217.199-2.39.265-1.173.045-2.247.078-3.22.1H9.562c-3.786 0-6.143-.122-7.073-.365-.863-.244-1.405-.775-1.627-1.594-.11-.42-.199-.996-.265-1.727-.045-.752-.078-1.383-.1-1.892v-.797c0-1.97.122-3.431.365-4.383.111-.398.31-.741.598-1.03.288-.287.63-.486 1.03-.597.42-.11 1.217-.188 2.39-.232A95.938 95.938 0 018.1.25h1.461c3.786 0 6.143.122 7.073.365.398.11.741.31 1.03.598.287.288.486.63.597 1.03zM7.703 9.348l4.748-2.723-4.748-2.69v5.413z"}})])
          )
        }
      }
    